module.exports = __webpack_public_path__ + "static/img/oca-report.2fed126.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/oca-report.jpg
// module id = +KtM
// module chunks = 0